// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  defaultauth: 'firebase',
  googleMapsApiKey: 'AIzaSyCuJYFhtO7dUUQC7cqxgeHu5BSOb5F9ZG0',
  firebaseConfig: {
    apiKey: "AIzaSyA7G0IsF90HvJe2CyVqv34MWK-fotR7SiI",
    authDomain: "futurapro-dev.firebaseapp.com",
    projectId: "futurapro-dev",
    storageBucket: "futurapro-dev.firebasestorage.app",
    messagingSenderId: "249563062579",
    appId: "1:249563062579:web:2adf3cbd656b3f65cd1e46"
  }
};


